import { Typography } from "antd";

export interface ModalDeleteConfirmationProps {
  // Lowercase noun, e.g. "questionnaire", "company".
  readonly entityLabel: string;
  readonly entityName?: string | null;
  readonly additionalText?: string;
  // Gerund for the action — defaults to "deleting"; pass e.g. "removing" for unassign-style dialogs.
  readonly verb?: string;
}

// Centralized delete-confirmation body so the wording + typography are identical everywhere.
// Admin requirement 2026-11-03 — records are ARCHIVED, not hard-deleted. Soft-delete is the backend
// behaviour already; the UI copy now matches so operators understand nothing is destroyed.
function ModalDeleteConfirmation(props: ModalDeleteConfirmationProps) {
  const verb = props.verb ?? "archiving";
  return (
    <Typography.Paragraph>
      <Typography.Text>
        {props.entityName ? (
          <>
            Continue {verb} the{" "}
            <Typography.Text className="font-bold">
              {props.entityName}
            </Typography.Text>{" "}
            {props.entityLabel}?
          </>
        ) : (
          <>Continue {verb} this {props.entityLabel}?</>
        )}
        {props.additionalText ? ` ${props.additionalText}` : ""}
        <br />
        <Typography.Text type="secondary" className="text-xs">
          The {props.entityLabel} will be archived (hidden from active lists) rather than removed —
          historical data stays intact for reporting.
        </Typography.Text>
      </Typography.Text>
    </Typography.Paragraph>
  );
}

export default ModalDeleteConfirmation;
